/**
 * Increments or Decrements the h tag between h1 and h6.
 * @param  {HTMLCollection|Array} h_arr List/Array of h elements to be incremented.
 * @param  {Boolean} [dec=false] If true the function will decrement the tag.
 */
function hInc(h_arr, dec = false) {
  let incrementer = dec ? -1 : 1;
  [...h_arr].forEach(h => {
    const h_outer = h.outerHTML;

    const h_regx = /(<|(?:<\/))h([0-9])/gi;

    const modified =  h_outer.replace(h_regx, (_, prefix, h_str) => {
      let raw_level = parseInt(h_str) + incrementer;
      let level = Math.min(Math.max(1, raw_level), 6);
      return `${prefix}h${level}`;
    });

    h.outerHTML = modified;
  });
}

export default hInc;
